<template>
  <base-modal modal-content-class="resub">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_resubscribe_confirmation_title }}</h1>

      <h2>{{ $_getTranslations.home_modals_resubscribe_confirmation_you_are_not_subscribed }}</h2>

      <p>{{ $_getTranslations.home_modals_resubscribe_confirmation_in_order_to_unlock }}</p>

      <base-button container-class="resub_btn" @button:click="reOptin">
        {{ $_getTranslations.home_modals_resubscribe_confirmation_resubscribe }}
      </base-button>

      <p v-if="!reoptinOnestep">
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt1 }}
        <span class="white_bold">{{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt2 }}</span>
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt3 }}
        <a :href="termsAndConditionsLink" target="_blank">
          {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt4 }}
        </a>
        {{ $_getTranslations.home_modals_resubscribe_confirmation_terms_pt5 }}
      </p>
    </div>
  </base-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import WelcomeReturningUnsub from './WelcomeReturningUnsub'
import ResubscribeViaPin from './ResubscribeViaPin'
import ResubscribeError from './ResubscribeError'
import integrationMixin from '../../../common/mixins/integration'
import translationMixin from '../../../common/mixins/translation'
import modals from '../../../common/modals'
import {apiResponseTypeEnum} from '../../../constants/api'

export default {
  name: 'resubscribe-game',
  components: {BaseButton, BaseModal},
  mixins: [
    integrationMixin,
    translationMixin
  ],
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails'
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
      'storeModalForSettings',
      'storeModalForHomePage'
    ]),
    showResubModal (modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal)
        modals.setupCommonModal({
          afterHideCallback: () => {
            this.storeModalForStore(null)
          }
        })
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/profile/edit') {
        this.storeModalForSettings(modal)
        modals.showHideModalForHomePage(this)
      } else {
        this.storeModalForHomePage(modal)
        modals.showHideModal(this)
      }
    },
    reSubCallback (response) {
      if (response.data.responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.showResubModal(WelcomeReturningUnsub)
            } else {
              this.showResubModal(ResubscribeError)
            }
          } else {
            // eslint-disable-next-line
            if (!this.userDetails.subscribed) {
              this.showResubModal(ResubscribeViaPin)
            } else {
              this.showResubModal(ResubscribeError)
            }
          }
        })
      } else {
        this.showResubModal(ResubscribeError)
      }
    },
    reOptin () {
      this.getAppropriateReSubAction()
    }
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep'
    ]),
    termsAndConditionsLink () {
      return this.$_translateTextByOperator({key: 'project_config_visitor_register_3_terms_and_conditions'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGame.vue